export const BRAND = {
  mantra: "Breathe. Chill. Drink Lemonade.",
  logo: "/brand/logo.png",
  quote:
    "Anyone can make lemonade. But Smash Lemonade is about proving you can flip challenges into opportunities. We didn't wait for a moment — we created one.",
  taglines: [
    "BREATHE. CHILL. DRINK LEMONADE",
    "ONLY GOOD VIBES",
    "WELCOME TO THE SMASH LIFE",
    "THERAPY YOU CAN DRINK",
    "LEMONAID — DRINK FOR THE SOUL",
  ],
  photos: {
    tribal: "/brand/art-tribal.jpg",
    lips: "/brand/art-lips.jpg",
    lemonSplash: "/brand/art-lemon-splash.jpg",
    lemonPurple: "/brand/art-lemon-purple.jpg",
    graffitiTags: "/brand/art-graffiti-tags.jpg",
    graffitiColor: "/brand/art-graffiti-color.jpg",
    jarWall: "/brand/art-jar-wall.jpg",
    menu: "/brand/menu.jpg",
    hero: "https://smashlemonade.com/cdn/shop/files/IMG_9796.jpg?v=1764635718&width=1600",
    street: "https://smashlemonade.com/cdn/shop/files/IMG_9797.jpg?height=848&v=1764636123",
    cup: "https://smashlemonade.com/cdn/shop/files/IMG_9802.jpg?height=1024&v=1764636493",
  },
};

export const BrandMarquee = ({ items = BRAND.taglines }) => (
  <div
    className="relative overflow-hidden border-y border-border bg-primary py-2"
    data-testid="brand-marquee"
  >
    <div className="marquee-track">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex shrink-0 items-center">
          {items.map((t, i) => (
            <span
              key={`${dup}-${i}`}
              className="display px-6 text-lg text-primary-foreground"
            >
              {t} <span className="opacity-40">✕</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
